import { supabase } from "../../supabaseClient"

export const saveValueHour = async (id = undefined, item) => {
    if (id) {
        return await supabase
            .from('HourlyValue')
            .update({ ...item })
            .match({ id })
    } else {
        return await supabase
            .from('HourlyValue')
            .insert([{ ...item }])
    }
}